import { IconNameEnum, ColorEnum } from '@app/common';

export function ensureIconName(value: string): IconNameEnum {
    return Object.values(IconNameEnum).includes(value as IconNameEnum)
        ? (value as IconNameEnum)
        : IconNameEnum.WalletFilled;
}

export function ensureColorName(value: string): ColorEnum {
    return Object.values(ColorEnum).includes(value as ColorEnum) ? (value as ColorEnum) : ColorEnum.Blue;
}
